import { useState } from 'react';
import { Plus, Box, Disc, Briefcase } from 'lucide-react';
import { useDropdown } from '@/hooks/useDropdown';
import { useUIStore } from '@/stores/ui';

export function QuickAddDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = useUIStore((state) => state.openModal);
  const { openAddModelSidebar, openAddJobSidebar } = useUIStore();

  // Use the dropdown hook for proper event cleanup
  const menuRef = useDropdown({
    isOpen,
    onClose: () => setIsOpen(false),
  });

  const handleAddModel = () => {
    setIsOpen(false);
    openAddModelSidebar();
  };

  const handleAddSpool = () => {
    setIsOpen(false);
    openModal('add-spool');
  };

  const handleAddJob = () => {
    setIsOpen(false);
    openAddJobSidebar();
  };

  return (
    <div ref={menuRef} className="relative">
      {/* Trigger button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Quick add"
        className="
          flex h-8 w-8 items-center justify-center rounded-md
          text-foreground-muted hover:bg-background-hover hover:text-foreground
          transition-colors
        "
      >
        <Plus className="h-5 w-5" aria-hidden="true" />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          role="menu"
          className="
            absolute right-0 top-full mt-1 w-48 rounded-md border border-border
            bg-background-elevated shadow-lg z-50
          "
        >
          <div className="py-1">
            <button
              onClick={handleAddModel}
              role="menuitem"
              className="
                flex w-full items-center gap-2 px-4 py-2 text-sm
                text-foreground-muted hover:bg-background-hover hover:text-foreground
              "
            >
              <Box className="h-4 w-4" aria-hidden="true" />
              Add Model
            </button>
            <button
              onClick={handleAddSpool}
              role="menuitem"
              className="
                flex w-full items-center gap-2 px-4 py-2 text-sm
                text-foreground-muted hover:bg-background-hover hover:text-foreground
              "
            >
              <Disc className="h-4 w-4" aria-hidden="true" />
              Add Spool
            </button>
            <button
              onClick={handleAddJob}
              role="menuitem"
              className="
                flex w-full items-center gap-2 px-4 py-2 text-sm
                text-foreground-muted hover:bg-background-hover hover:text-foreground
              "
            >
              <Briefcase className="h-4 w-4" aria-hidden="true" />
              Add Job
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
